module.exports = __webpack_public_path__ + "static/media/instagram.a19b822d.svg";